export default {
  inject: ['pRoadType'],
  computed: {
    roadName() {
      return {
        HIGHWAY: '高速',
        NATIONAL_HIGHWAY: '国道',
        PROVINCIAL_HIGHWAY: '省道',
      }[this.pRoadType]
    },
    moduleName() {
      return {
        HIGHWAY: 'operateCollectionStat',
        NATIONAL_HIGHWAY: 'operateCollectionStat_national',
        PROVINCIAL_HIGHWAY: 'operateCollectionStat_provincial',
      }[this.pRoadType]
    },
    detailModuleName() {
      return {
        HIGHWAY: 'motorOperatorVehicleCount',
        NATIONAL_HIGHWAY: 'motorOperatorVehicleCount_national',
        PROVINCIAL_HIGHWAY: 'motorOperatorVehicleCount_provincial',
      }[this.pRoadType]
    },
    pTitleArr() {
      if (this.pRoadType != 'PROVINCIAL_HIGHWAY'){
        return [this.roadName + '运营数据', this.roadName + '加能站流量数据', this.roadName + '加能站停靠明细']
      }else{
        return [this.roadName + '加油站停靠统计', this.roadName + '运营时段统计']
      }
    },
    showWayProvinceDetail() {
      return this.pRoadType != 'PROVINCIAL_HIGHWAY'
    },
    showProvinceName() {
      return this.pRoadType == 'HIGHWAY'
    },
  },
}
